// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oxfV4YbGefzEZqW9DZ9w{display:flex;flex-direction:column;gap:4px}.UQOYyQ0WtsfZifuJEgAI{padding:12px}`, "",{"version":3,"sources":["webpack://./src/pages/workflows/ui/WorkflowManage/ui/actions/blocks/SendFrom/ui/SendFromBlockActionEditContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,OAAA,CAEF,sBACE,YAAA","sourcesContent":[".sendFrom {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.textField {\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sendFrom": `oxfV4YbGefzEZqW9DZ9w`,
	"textField": `UQOYyQ0WtsfZifuJEgAI`
};
export default ___CSS_LOADER_EXPORT___;
